import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Globals } from '../objects/Globals';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class RelatedService {
  private loginUrl:string;

  getRelatedDocuments(cardId:string, relationDefinition:string):Observable<string>{
    var path = this.loginUrl + "GetRelatedDocuments/" + cardId+ "/"+ relationDefinition;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getRelationCard(cardId:string):Observable<string>{
    var path = this.loginUrl + "GetRelationCard/" + cardId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectHighlightCard(cardId:string, docType:string, docId:string):Observable<string>{
    var path = this.loginUrl + "SelectRelationCardFocus/" + cardId + "/" + docType + "/" + docId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getCardListDetail(cardId:string, docType:string):Observable<string>{
    var path = this.loginUrl + "GetRelatedDocumentListDetails/" + cardId + "/" + docType;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  selectCard(cardId:string, docType:string, docId:string):Observable<string>{
    var path = this.loginUrl + "GetRelatedCardDetail/" + cardId + "/" + docType + "/" + docId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  constructor(private http:HttpClient, private globals:Globals, private env:EnvService) { this.loginUrl = this.env.servicePath; }
}
